(function () {
    'use strict';

    angular
        .module('adminControllers')
        .controller('AdminController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'permissionService'];

    function Controller($scope, $state, topBarService, permissionService) {

        if (!$scope.authenticatedUser.User.IsInAdministrationGroup) {
            $state.go('home');
        }

        topBarService.setModule(undefined);
        topBarService.setTitleAndIcon('Administration', 'fa fa-wrench');

        $scope.hasODDAccess = permissionService.hasPermission('ODDAdministrationManagement', 'Administration', 'CanLaunchEcho');
    }
})();